/**
 * Label for the site dashboard's delete/unshare action.
 *
 * A virtual site's delete affordance only ever unshares the site group's
 * access to it, never deactivates the underlying site — so its label and
 * accessible name must read "Unshare", not "Deactivate". SiteDashboardLayout's
 * top action bar and StructureCard's details-sheet icon (both title and
 * aria-label) all resolve the same wording from this one place.
 *
 * Contains:
 * - resolveDeleteSiteLabel — {isVirtual, isBillboard} + t -> localized label
 *
 * Returns plain JS — no JSX, no redux.
 */

/**
 * @param {Function} t - i18next translate fn.
 * @param {object} options
 * @param {boolean} options.isVirtual - Site is viewed through a virtual (shared-access) site group.
 * @param {boolean} options.isBillboard - Tenant uses "structure" terminology instead of "site".
 * @returns {string} The localized delete/unshare label.
 */
export function resolveDeleteSiteLabel(t, { isVirtual, isBillboard }) {
  if (isVirtual) {
    return t('actions.unshare');
  }
  return isBillboard ? t('sites.deactivateStructure') : t('sites.deactivateSite');
}
